class PredictiveSearch extends SearchForm {
	constructor() {
		super();
		this.cachedResults = {};
		this.predictiveSearchResults = this.querySelector(
			"[data-predictive-search]",
		);
		this.allPredictiveSearchInstances =
			document.querySelectorAll("predictive-search");
		this.isOpen = false;
		this.abortController = new AbortController();
		this.searchTerm = "";
		this.body = document.querySelector("body");
		this.headerBottom = document.querySelector(".header__bottom");
		this.promoModal = document.querySelector(".search__modal");
		this.headerInput = document.querySelector(".search-modal__form .search__input");
		this.isMobileSearch = window.matchMedia("(max-width: 989px)").matches;
		this.searchContainer =
			this.headerInput?.closest(".search-container") ||
			document.querySelector(".search-container");
		this.searchTrap = {
			keydown: null,
			focusin: null,
			lastFocused: null,
		};
		this.mobileSearchAriaHiddenElements = [];
		if (this.headerInput && this.isMobileSearch) {
			this.headerInput.addEventListener("focus", () => {
				if (this.searchContainer) {
					this.searchContainer.setAttribute("role", "dialog");
					this.searchContainer.setAttribute("aria-modal", "true");
					this.searchContainer.classList.add("is-mobile-search");
					this.applySearchContainerTrap(this.searchContainer);
					
					
				}				
			});
			if (this.searchContainer) {
				this.searchContainer.addEventListener("focusout", () => {
					setTimeout(() => {
						if (
							this.searchContainer.classList.contains("is-mobile-search") &&
							!this.searchContainer.contains(document.activeElement)
						) {
							this.searchContainer.classList.remove("is-mobile-search");
							this.searchContainer.removeAttribute("role");
							this.searchContainer.removeAttribute("aria-modal");
							this.removeSearchContainerTrap(false);
							this.close(true);
						}
					}, 0);
				});
			}
		}
		document.querySelectorAll(".modal-close-button").forEach((button) => {
			button.addEventListener("click", () => {
				if (this.searchContainer) {
					this.searchContainer.classList.remove("is-mobile-search");
					this.searchContainer.removeAttribute("role");
					this.searchContainer.removeAttribute("aria-modal");
					this.removeSearchContainerTrap(false);
				}
				this.close(true);
			});
		});
		this.calcHeight();
		this.setupEventListeners();

		const searchResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			if (entry.contentRect.width < 991) {
				this.calcHeight(65);
			} else {
				this.calcHeight(0);
			}
		});

		searchResizeObserver.observe(this.body);
	}

	getFocusableElements(container) {
		return Array.from(
			container.querySelectorAll(
				"a[href], button:not([disabled]), textarea:not([disabled]), input:not([type='hidden']):not([disabled]), select:not([disabled]), [tabindex]:not([tabindex='-1'])",
			),
		).filter((element) => element.getAttribute("aria-hidden") !== "true");
	}

	applySearchContainerTrap(container) {
		if (!container) return;
		this.removeSearchContainerTrap(false);
		this.searchTrap.lastFocused = document.activeElement;
		this.applyMobileSearchAriaHidden();

		const focusableElements = this.getFocusableElements(container);
		const firstFocusable = focusableElements[0] || container;
		const lastFocusable =
			focusableElements[focusableElements.length - 1] || container;

		if (!container.hasAttribute("tabindex")) {
			container.setAttribute("tabindex", "-1");
		}

		this.searchTrap.keydown = (event) => {
			if (event.key !== "Tab") return;

			if (!focusableElements.length) {
				event.preventDefault();
				container.focus();
				return;
			}

			const activeElement = document.activeElement;
			if (event.shiftKey) {
				if (activeElement === firstFocusable || activeElement === container) {
					event.preventDefault();
					lastFocusable.focus();
				}
			} else if (activeElement === lastFocusable) {
				event.preventDefault();
				firstFocusable.focus();
			}
		};

		this.searchTrap.focusin = (event) => {
			if (!container.classList.contains("is-mobile-search")) return;
			if (!container.contains(event.target)) {
				firstFocusable.focus();
			}
		};

		document.addEventListener("keydown", this.searchTrap.keydown);
		document.addEventListener("focusin", this.searchTrap.focusin);

		setTimeout(() => {
			firstFocusable.focus();
		}, 0);
	}

	removeSearchContainerTrap(restoreFocus = true) {
		if (this.searchTrap?.keydown) {
			document.removeEventListener("keydown", this.searchTrap.keydown);
			this.searchTrap.keydown = null;
		}
		if (this.searchTrap?.focusin) {
			document.removeEventListener("focusin", this.searchTrap.focusin);
			this.searchTrap.focusin = null;
		}
		if (
			restoreFocus &&
			this.searchTrap?.lastFocused &&
			typeof this.searchTrap.lastFocused.focus === "function"
		) {
			this.searchTrap.lastFocused.focus();
		}
		if (this.searchTrap) {
			this.searchTrap.lastFocused = null;
		}
		this.restoreMobileSearchAriaHidden();
	}

	applyMobileSearchAriaHidden() {
		const targets = document.querySelectorAll(
			".announcement-bar, header-drawer, .header__heading, .header__heading-link",
		);
		const allTargets = new Set();
		Array.from(targets).forEach((element) => {
			allTargets.add(element);
			element.querySelectorAll("a").forEach((anchor) => allTargets.add(anchor));
			element.querySelectorAll("img").forEach((image) => allTargets.add(image));
		});

		this.mobileSearchAriaHiddenElements = Array.from(allTargets).map((element) => ({
			element,
			previousValue: element.getAttribute("aria-hidden"),
		}));

		this.mobileSearchAriaHiddenElements.forEach(({ element }) => {
			element.setAttribute("aria-hidden", "true");
		});
	}

	restoreMobileSearchAriaHidden() {
		if (!this.mobileSearchAriaHiddenElements.length) return;

		this.mobileSearchAriaHiddenElements.forEach(
			({ element, previousValue }) => {
				if (previousValue === null) {
					element.removeAttribute("aria-hidden");
				} else {
					element.setAttribute("aria-hidden", previousValue);
				}
			},
		);

		this.mobileSearchAriaHiddenElements = [];
	}

	calcHeight(buttonHeight) {
		let heightAnnouncementBar = document.querySelector(".section-announcement")
			? document.querySelector(".section-announcement").getBoundingClientRect()
					.height
			: 0;
		let heightHeader = document.querySelector(".shopify-section-header")
			? document
					.querySelector(".shopify-section-header")
					.getBoundingClientRect().height
			: 0;
		let heightSearchTop = document.querySelector(".search-modal__top")
			? document.querySelector(".search-modal__top").getBoundingClientRect()
					.height
			: 0;

		let heightInput = 0;

		if (document.querySelector(".predictive-search")) {
			let maxHeightContent = parseFloat(
				window
					.getComputedStyle(document.querySelector(".predictive-search"), null)
					.getPropertyValue("max-height"),
			);
			let heightContent = document
				.querySelector(".predictive-search")
				.getBoundingClientRect().height;

			let clientHeight = document.documentElement.clientHeight;
			let maxHeightAllowed =
				clientHeight -
				heightAnnouncementBar -
				heightHeader -
				heightSearchTop -
				heightInput -
				buttonHeight -
				10;
			document.querySelector(
				".predictive-search",
			).style.maxHeight = `${maxHeightAllowed}px`;
		}
	}

	setupEventListeners() {
		this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
		this.input.addEventListener("focus", this.onFocus.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.addEventListener("keyup", this.onKeyup.bind(this));
		this.addEventListener("keydown", this.onKeydown.bind(this));
	}

	getQuery() {
		return this.input.value.trim();
	}

	onChange() {
		const newSearchTerm = this.getQuery();
		if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
			// Remove the results when they are no longer relevant for the new search term
			// so they don't show up when the dropdown opens again
			this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
		}

		// Update the term asap, don't wait for the predictive search query to finish loading
		this.updateSearchForTerm(this.searchTerm, newSearchTerm);

		this.searchTerm = newSearchTerm;

		if (!this.searchTerm.length) {
			this.close(true);
			return;
		}

		this.getSearchResults(this.searchTerm);
	}

	onFormSubmit(event) {
		if (
			!this.getQuery().length ||
			this.querySelector('[aria-selected="true"] a') ||
			event.submitter.classList.contains("card__link")
		)
			event.preventDefault();
	}

	onFormReset(event) {
		super.onFormReset(event);
		if (super.shouldResetForm()) {
			this.searchTerm = "";
			this.abortController.abort();
			this.abortController = new AbortController();
			this.closeResults(true);
		}
	}

	onFocus() {
		const currentSearchTerm = this.getQuery();
		if (this.classList.contains("search-modal__form")) {
			if (this.headerBottom) {
				this.headerBottom.classList.add("header__bottom--visible");
			}
			if (this.promoModal) {
				this.promoModal.classList.remove("search__modal--hidden");
			}
		}

		if (!currentSearchTerm.length) {
			return;
		}

		if (this.searchTerm !== currentSearchTerm) {
			// Search term was changed from other search input, treat it as a user change
			this.onChange();
		} else if (this.getAttribute("results") === "true") {
			this.open();
			if (this.promoModal) {
				this.promoModal.classList.add("search__modal--hidden");
			}
		} else {
			this.getSearchResults(this.searchTerm);
		}
	}

	onFocusOut() {
		if (this.classList.contains("search-modal__form")) {
			if (this.headerBottom) {
				this.headerBottom.classList.remove("header__bottom--visible");
			}
		}

		setTimeout(() => {
			if (this.contains(document.activeElement)) return;

			const isDesktop = !window.matchMedia("(max-width: 989px)").matches;
			if (this.classList.contains("search-modal__form") && !isDesktop) return;

			this.close();
		});
	}

	onBlur() {
		this.headerInput.blur();
	}

	onKeyup(event) {
		if (!this.getQuery().length) this.close(true);
		event.preventDefault();

		switch (event.code) {
			//case "ArrowUp":
			//	this.switchOption("up");
			//	break;
			//case "ArrowDown":
			//	this.switchOption("down");
			//	break;
			case "Enter":
				event.preventDefault();
				this.selectOption();
				break;
			case "Escape":
				this.closeResults(true);
				if (this.promoModal && this.classList.contains("search-modal__form")) {
					this.promoModal.classList.add("search__modal--hidden");
				}
				break;
		}

		if (this.getQuery().length) {
			this.hidePromoBlock();
		} else {
			this.showPromoBlock();
		}
	}

	onKeydown(event) {
		// Prevent the cursor from moving in the input when using the up and down arrow keys
		if (event.code === "ArrowUp" || event.code === "ArrowDown") {
			event.preventDefault();
		}
	}

	updateSearchForTerm(previousTerm, newTerm) {
		const searchForTextElement = this.querySelector(
			"[data-predictive-search-search-for-text]",
		);
		const currentButtonText = searchForTextElement?.innerText;
		if (currentButtonText) {
			if (
				currentButtonText.matchAll(new RegExp(previousTerm, "g")).length > 1
			) {
				// The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
				return;
			}
			const newButtonText = currentButtonText.replace(previousTerm, newTerm);
			searchForTextElement.innerText = newButtonText;
		}
		if (this.getQuery().length) {
			this.hidePromoBlock();
		} else {
			this.showPromoBlock();
		}
	}

	//switchOption(direction) {
	//	if (!this.getAttribute("open")) return;

	//	const moveUp = direction === "up";
	//	const selectedElement = this.querySelector('[aria-selected="true"]');

	//	// Filter out hidden elements (duplicated page and article resources) thanks
	//	// to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
	//	const allVisibleElements = Array.from(
	//		this.querySelectorAll("li, button.predictive-search__item"),
	//	).filter((element) => element.offsetParent !== null);
	//	let activeElementIndex = 0;

	//	if (moveUp && !selectedElement) return;

	//	let selectedElementIndex = -1;
	//	let i = 0;

	//	while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
	//		if (allVisibleElements[i] === selectedElement) {
	//			selectedElementIndex = i;
	//		}
	//		i++;
	//	}

	//	this.statusElement.textContent = "";

	//	if (!moveUp && selectedElement) {
	//		activeElementIndex =
	//			selectedElementIndex === allVisibleElements.length - 1
	//				? 0
	//				: selectedElementIndex + 1;
	//	} else if (moveUp) {
	//		activeElementIndex =
	//			selectedElementIndex === 0
	//				? allVisibleElements.length - 1
	//				: selectedElementIndex - 1;
	//	}

	//	if (activeElementIndex === selectedElementIndex) return;

	//	const activeElement = allVisibleElements[activeElementIndex];

	//	activeElement.setAttribute("aria-selected", true);
	//	if (selectedElement) selectedElement.setAttribute("aria-selected", false);

	//	this.input.setAttribute("aria-activedescendant", activeElement.id);
	//}

	selectOption() {
		const selectedOption = this.querySelector(
			'[aria-selected="true"] a, button[aria-selected="true"]',
		);

		if (selectedOption) selectedOption.click();
	}

	getSearchResults(searchTerm) {
		const queryKey = searchTerm.replace(" ", "-").toLowerCase();
		this.setLiveRegionLoadingState();

		if (this.cachedResults[queryKey]) {
			this.renderSearchResults(this.cachedResults[queryKey]);
			this.clickSearchTabs();
			this.calcHeight();
			return;
		}

		if (this.promoModal && this.classList.contains("search-modal__form")) {
			this.promoModal.classList.add("search__modal--hidden");
		}

		fetch(
			`${routes.predictive_search_url}?q=${encodeURIComponent(
				searchTerm,
			)}&resources[type]=product,collection,article,page&section_id=predictive-search`,
			{ signal: this.abortController.signal },
		)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}
				return response.text();
			})
			.then((text) => {
				const resultsMarkup = new DOMParser()
					.parseFromString(text, "text/html")
					.querySelector("#shopify-section-predictive-search").innerHTML;
				// Save bandwidth keeping the cache in all instances synced
				this.allPredictiveSearchInstances.forEach(
					(predictiveSearchInstance) => {
						predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
					},
				);
				this.renderSearchResults(resultsMarkup);
				this.clickSearchTabs();
				this.calcHeight();
				try {
					colorSwatches();
				} 
				catch(err) {}
			})
			.catch((error) => {
				if (error?.code === 20) {
					// Code 20 means the call was aborted
					return;
				}
				this.close();
				throw error;
			});
	}

	setLiveRegionLoadingState() {
		this.statusElement =
			this.statusElement || this.querySelector(".predictive-search-status");
		this.loadingText =
			this.loadingText || this.getAttribute("data-loading-text");

		this.setLiveRegionText(this.loadingText);
		this.setAttribute("loading", true);
	}

	setLiveRegionText(statusText) {
		this.statusElement.setAttribute("aria-hidden", "false");
		this.statusElement.textContent = statusText;

		setTimeout(() => {
			this.statusElement.setAttribute("aria-hidden", "true");
		}, 1000);
	}

	renderSearchResults(resultsMarkup) {
		this.predictiveSearchResults.innerHTML = resultsMarkup;
		this.setAttribute("results", true);

		this.setLiveRegionResults();
		this.open();
		if (this.promoModal && this.classList.contains("search-modal__form")) {
			this.promoModal.classList.add("search__modal--hidden");
		}
	}

	clickSearchTabs() {
		const results = this.querySelectorAll(".predictive-search__results-list");
		if (results.length != 0) {
			results[0].classList.add("active");
			this.querySelector(".predictive-search__result-tab").classList.add(
				"active",
			);
			this.querySelectorAll(".predictive-search__result-tab").forEach((tab) => {
				tab.addEventListener("click", (event) => {
					event.preventDefault();
					const typeTarget = tab.dataset.typeTarget;
					this.querySelectorAll(".predictive-search__result-tab").forEach(
						(element) => {
							element.classList.remove("active");
						},
					);
					tab.classList.add("active");

					results.forEach((element) => {
						let resultsType = element.dataset.type;
						if (resultsType == typeTarget) {
							element.classList.add("active");
						} else {
							element.classList.remove("active");
						}
					});
				});
			});
		}
	}

	hidePromoBlock() {
		document.querySelector(".search__categories")
			? document.querySelector(".search__categories").classList.add("hide")
			: false;
		document.querySelector(".search__promo-block")
			? document.querySelector(".search__promo-block").classList.add("hide")
			: false;
		document.querySelector(".search__line")
			? document.querySelector(".search__line").classList.add("hide")
			: false;
	}

	showPromoBlock() {
		document.querySelector(".search__categories")
			? document.querySelector(".search__categories").classList.remove("hide")
			: false;
		document.querySelector(".search__promo-block")
			? document.querySelector(".search__promo-block").classList.remove("hide")
			: false;
		document.querySelector(".search__line")
			? document.querySelector(".search__line").classList.remove("hide")
			: false;
	}

	setLiveRegionResults() {
		this.removeAttribute("loading");
		this.setLiveRegionText(
			this.querySelector("[data-predictive-search-live-region-count-value]")
				.textContent,
		);
	}

	//getResultsMaxHeight() {
	//	this.resultsMaxHeight =
	//		window.innerHeight -
	//		document.querySelector(".shopify-section-header").getBoundingClientRect()
	//			.bottom;
	//	return this.resultsMaxHeight;
	//}

	open() {
		//this.predictiveSearchResults.style.maxHeight =
		//	this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
		this.setAttribute("open", true);
		this.input.setAttribute("aria-expanded", true);
		this.isOpen = true;
		if (this.promoModal && this.classList.contains("search-modal__form")) {
			this.promoModal.classList.remove("search__modal--hidden");
		}
		let overlayContainer = document.querySelector('.search-modal__overlay');
		overlayContainer.classList.add("active");

	}

	close(clearSearchTerm = false) {
		this.closeResults(clearSearchTerm);
		this.isOpen = false;
		this.removeSearchContainerTrap(false);
		document.querySelectorAll('.search-container.is-mobile-search').forEach((container) => {
			container.classList.remove('is-mobile-search');
			container.removeAttribute('role');
			container.removeAttribute('aria-modal');
		});
		let overlayContainer = document.querySelector('.search-modal__overlay');
		overlayContainer.classList.remove("active");
	}

	closeResults(clearSearchTerm = false) {
		if (clearSearchTerm) {
			this.input.value = "";
			this.removeAttribute("results");
		}
		const selected = this.querySelector('[aria-selected="true"]');

		if (selected) selected.setAttribute("aria-selected", false);

		this.input.setAttribute("aria-activedescendant", "");
		this.removeAttribute("loading");
		this.removeAttribute("open");
		this.input.setAttribute("aria-expanded", false);
		//this.resultsMaxHeight = false;
		this.predictiveSearchResults.removeAttribute("style");
		if (this.promoModal) {
			this.promoModal.classList.add("search__modal--hidden");
		}
	}
}

customElements.define("predictive-search", PredictiveSearch);
